// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_content__uGdsj","placeholder":"Modal_placeholder__qt19l","container":"Modal_container__twkb8","header":"Modal_header__atbYa","closeBtn":"Modal_closeBtn__fmKDd"};